import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'form:not(.without-default-focus)',
    standalone: true,
})
export class FormFocusDirective implements AfterViewInit {
    focusables = ['input', 'select', 'mat-select', 'textarea'];

    constructor(
        private element: ElementRef,
        private cdRef: ChangeDetectorRef
    ) {}

    ngAfterViewInit() {
        const inputs = this.element.nativeElement.querySelectorAll(this.focusables.join(','));
        if (inputs) {
            for (let index = 0; index < inputs.length; index++) {
                let element = inputs[index];

                if (element.disabled == false) {
                    element.focus();
                    this.cdRef.detectChanges();
                    break;
                }
            }
        }
    }

    @HostListener('submit')
    submit() {
        const input = this.element.nativeElement.querySelector(this.focusables.map((x) => `${x}.ng-invalid`).join(','));
        if (input) {
            input.focus();
        }
    }
}
